import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import Level1 from '../scenes/Level1';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Bubbles from './Bubbles';
import TentancleGrabber from './TentancleGrabber';
import Treasure from './Treasure';

export default class WordController extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Level1} scene 
   */
  constructor(scene) {
    super(scene);
    this.scene = scene;

    /** @type {Phaser.GameObjects.Text[]} */
    this.letters = [];

    /** @type {Phaser.GameObjects.Image[]} */
    this.boxes = [];

    /** @type {Phaser.GameObjects.Zone[]} */
    this.masks = [];
    this.answers = [];
    this.startLocs = [];
    this.shadersAdj = [];

    /** @type {{ letter: Phaser.GameObjects.Text, filled: boolean }[]} */
    this.hints = [];

    /** @type {Phaser.GameObjects.Image[]} */
    this.pops = [];

    /** @type {Phaser.Tweens.Tween[]} */
    this.letterTweens = [];

    /** @type {Phaser.Tweens.Tween[]} */
    this.maskTweens = [];

    this.droppedInd = null;
    this.word = null;
    this.boxCont = null;
    this.returnInd = null;

    /** @type {string} */
    this.chosenWord = null;
    this.transition = null;

    this.score = 1;
    this.wordInd = 0;

    this.initUpdate = false;
    this.initDropper = false;

    this.setup();
  }

  setup() {
    if (gameData.config.level === 1) {
      this.initDropper = true;
    }

    if (gameData.config.level === 1) {
      // add instructions
      this.instructionsPopup = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height / 2 - 125, UIAssetKeys._InstructionPopUp, this.scene).setScale(0);
      this.instructionsArrow = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2 + 250, this.scene.scale.height / 2 + 300, UIAssetKeys._Instruction_Arrow, this.scene).setOrigin(0, 0.5)
        .setAlpha(0);
      this.instructionsCloseBtn = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height / 2 - 25, UIAssetKeys._Instructions_CloseButton, this.scene).setScale(0)
        .setInteractive({ useHandCursor: true })
        .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.destroyInstructions, this);
    }

    this.createWords(true);
    this.createBoxes();
    this.releaseWords();
  }

  destroyInstructions() {
    this.scene.tweens.killTweensOf(this.instructionsPopup);
    this.scene.tweens.killTweensOf(this.instructionsCloseBtn);
    this.scene.tweens.killTweensOf(this.instructionsArrow);
    this.instructionsPopup.destroy();
    this.instructionsArrow.destroy();
    this.instructionsCloseBtn.destroy();

    this.instructionsPopup = null;
    this.instructionsCloseBtn = null;
    this.instructionsArrow = null;
  }

  createWords(isInit) {
    this.initUpdate = false;

    if (isInit) {
      Phaser.Utils.Array.Shuffle(gameData.config.levelWordBank);
    }
    else {
      gameData.config.levelWordBank.push(gameData.config.levelWordBank.shift());
    }

    this.word = gameData.config.levelWordBank[0].split('');
    this.chosenWord = gameData.config.levelWordBank[0];

    let tempArr = this.word.slice();

    while (compareArrays(tempArr, this.word) === true) {
      Phaser.Utils.Array.Shuffle(tempArr);

      if (compareArrays(tempArr, 'shit') === true) {
        // don't allow "shit" to be displayed
        tempArr = this.word.slice();
      }
    }

    for (let w = 0; w < tempArr.length; w++) {
      const txt = ABCyaPhaser.Text.addText(0, 0, 80, 0xffffff, FontKeys._rolling_no_oneregular, tempArr[w], this.scene, true).setOrigin(0.5);

      if (gameData.config.level === 1) {
        txt.tint = 0x21409a;
      }
      else if (gameData.config.level === 2) {
        txt.tint = 0x0B3F20;
      }
      else if (gameData.config.level === 3) {
        txt.tint = 0x1CC1F4;
      }
      else if (gameData.config.level === 4) {
        txt.tint = 0x80E900;
      }
      txt.startInd = w;
      txt.ind = null;

      const shader = this.scene.add.zone(0, 0, txt.width + 6, txt.height + 16).setInteractive({ useHandCursor: true, draggable: true })
        .setOrigin(0)
        .disableInteractive();

      shader.startInd = w;
      shader.letter = tempArr[w];

      this.masks.push(shader);
      this.letters.push(txt);

      this.answers[w] = null;
    }
  }

  createBoxes() {
    this.boxCont = this.scene.add.container();
    this.add(this.boxCont);

    let box = null;
    for (let i = 0; i < this.word.length; i++) {
      box = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._3_Level_Assets_Common_LtrTile, this.boxCont).setScale(1.1, 1);
      box.setPosition((box.displayWidth + 10) * i, 0);
      box.alpha = 0;

      const txt = ABCyaPhaser.Text.addText(box.x - 1, 0, 80, 0xffffff, FontKeys._rolling_no_oneregular, this.word[i], this.boxCont, true).setOrigin(0.5);
      this.boxCont.add(txt);
      txt.alpha = 0;

      this.boxes.push(box);
      this.hints.push({ letter: txt, filled: false });

      ABCyaPhaser.Tweens.addTween(box, 2000, { alpha: 1, delay: 500 }, Phaser.Math.Easing.Linear);
    }

    this.boxCont.setPosition(this.scene.scale.width / 2 - this.boxCont.getBounds().width / 2 + box.width / 2, this.scene.scale.height / 2 + 100);

    if (this.instructionsArrow !== null && this.instructionsArrow !== undefined) {
      this.instructionsArrow.x = this.scene.scale.width / 2 + this.boxCont.getBounds().width / 2 + 10;

      ABCyaPhaser.Tweens.addTween(this.instructionsPopup, 500, { scale: 1 }, Phaser.Math.Easing.Back.Out);
      ABCyaPhaser.Tweens.addTween(this.instructionsCloseBtn, 250, { scale: 1, delay: 500 }, Phaser.Math.Easing.Back.Out);
      ABCyaPhaser.Tweens.addTween(this.instructionsArrow, 1000, { alpha: 1, delay: 1500 }, Phaser.Math.Easing.Linear);
      ABCyaPhaser.Tweens.addTween(this.instructionsArrow, 1000, { x: this.instructionsArrow.x - 10, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
    }
  }

  releaseWords() {
    for (let w = 0; w < this.letters.length; w++) {
      this.letters[w].setPosition(this.boxes[w].x + this.boxCont.x, this.scene.scale.height + 100);

      this.masks[w].setPosition(this.letters[w].x - this.letters[w].width / 2 - 3, this.letters[w].y - this.letters[w].height / 2);

      this.startLocs[w] = { x: this.letters[w].x, y: this.scene.scale.height / 2 + 300 };
      this.shadersAdj[w] = { x: this.letters[w].width / 2 + 3, y: this.letters[w].height / 2 };

      const randDel = Phaser.Math.Between(0, 500);
      ABCyaPhaser.Tweens.addTween(this.letters[w], 2000, { y: this.startLocs[w].y, delay: randDel }, Phaser.Math.Easing.Sine.Out);
      ABCyaPhaser.Tweens.addTween(this.masks[w], 2000, { y: this.startLocs[w].y - this.shadersAdj[w].y, delay: randDel }, Phaser.Math.Easing.Sine.Out);
    }

    this.scene.time.delayedCall(2500, this.enablePlay, null, this);
  }

  enablePlay() {
    for (let i = 0; i < this.letters.length; i++) {
      this.scene.tweens.killTweensOf(this.letters[i]);
      this.letterTweens[i]?.stop();

      this.scene.tweens.killTweensOf(this.masks[i]);
      this.maskTweens[i]?.stop();

      this.idleLetter(this.letters[i], this.masks[i]);
    }

    ABCyaPhaser.Audio.playOneShot(this.chosenWord, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.enableMasks();

    this.scene.sub.enableButtons();
    this.scene.navBar.enableButtons();
  }

  enableMasks() {
    for (let i = 0; i < this.masks.length; i++) {
      this.masks[i].setInteractive();
      this.scene.input.setDraggable(this.masks[i]);
      this.masks[i].on(Phaser.Input.Events.GAMEOBJECT_DRAG_START, () => this.handleDragStart(this.masks[i]));
      this.masks[i].on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.handleDragStop(this.masks[i]));
      this.masks[i].on(Phaser.Input.Events.GAMEOBJECT_DRAG, (pointer, x, y) => this.handleDragUpdate(this.masks[i], x, y));
    }
  }

  /**
   * 
   * @param {Phaser.GameObjects.Zone} obj 
   */
  handleDragStart(obj) {
    if (this.instructionsPopup !== null && this.instructionsPopup !== undefined) {
      this.destroyInstructions();
    }
    const letterInd = this.masks.indexOf(obj);
    const box = this.letters[this.masks.indexOf(obj)];

    ABCyaPhaser.Audio.playOneShot(box.text, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    if (box.ind !== null && this.answers[box.ind] !== null) {
      this.hints[box.ind].filled = false;
      this.answers[box.ind] = null;
      box.ind = null;
      this.droppedInd = null;
    }

    this.scene.tweens.killTweensOf(obj);
    this.scene.tweens.killTweensOf(this.letters[letterInd]);
    this.letterTweens[letterInd]?.stop();
    this.maskTweens[letterInd]?.stop();

    this.letterTweens.splice(letterInd, 1);
    this.maskTweens.splice(letterInd, 1);

    this.scene.children.bringToTop(box);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Zone} obj 
   */
  handleDragStop(obj) {
    this.droppedInd = null;

    const box = this.letters[this.masks.indexOf(obj)];

    for (let w = 0; w < this.boxes.length; w++) {
      const success = Phaser.Geom.Rectangle.ContainsPoint(this.boxes[w].getBounds(), new Phaser.Geom.Point(this.scene.input.activePointer.position.x, this.scene.input.activePointer.position.y));
      if (success) this.droppedInd = w;
    }

    this.setWordPos(box);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Zone} obj 
   */
  handleDragUpdate(obj, x, y) {
    obj.setPosition(x, y);
    this.letters[this.masks.indexOf(obj)].setPosition(obj.x + obj.width / 2 - 1, obj.y + obj.height / 2 - 11);
  }

  setWordPos(obj) {
    const mask = this.masks[this.letters.indexOf(obj)];

    if (this.droppedInd !== null && this.droppedInd !== undefined) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._placing_letter, this.scene);

      // snap to space
      for (let a = 0; a < this.letters.length; a++) {
        if (this.letters[a].ind === this.droppedInd) {
          // send the letter that is already in the space back to its starting position

          this.returnInd = a;

          this.hints[a].filled = false;

          this.letters[a].ind = null;

          ABCyaPhaser.Tweens.addTween(this.letters[a], 150, { x: this.startLocs[this.letters[a].startInd].x, y: this.startLocs[this.letters[a].startInd].y }, Phaser.Math.Easing.Quadratic.Out);
          ABCyaPhaser.Tweens.addTween(this.masks[a], 150, { x: this.startLocs[this.letters[a].startInd].x - this.shadersAdj[this.letters[a].startInd].x, y: this.startLocs[this.letters[a].startInd].y - this.shadersAdj[this.letters[a].startInd].y }, Phaser.Math.Easing.Quadratic.Out, () => {
            this.idleLetter(this.letters[this.returnInd], this.masks[this.returnInd], this.returnInd);
          });
        }
      }

      // eslint-disable-next-line no-param-reassign
      obj.ind = this.droppedInd;
      this.answers[this.droppedInd] = obj.text;
      this.hints[this.droppedInd].filled = true;

      ABCyaPhaser.Tweens.addTween(obj, 100, { x: this.boxes[this.droppedInd].x - 1 + this.boxCont.x, y: this.boxes[this.droppedInd].y + this.boxCont.y }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Tweens.addTween(mask, 100, { x: this.boxes[this.droppedInd].x - 1 + this.boxCont.x - this.shadersAdj[obj.startInd].x, y: this.boxes[this.droppedInd].y + this.boxCont.y - this.shadersAdj[obj.startInd].y }, Phaser.Math.Easing.Quadratic.Out);
    }
    else {
      // send back to origin
      if (obj.ind !== null && this.answers[obj.ind] !== null) {
        this.hints[obj.ind].filled = false;

        this.answers[obj.ind] = null;
        // eslint-disable-next-line no-param-reassign
        obj.ind = null;
        this.droppedInd = null;
      }

      ABCyaPhaser.Tweens.addTween(obj, 150, { x: this.startLocs[obj.startInd].x, y: this.startLocs[obj.startInd].y }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Tweens.addTween(mask, 150, { x: this.startLocs[obj.startInd].x - this.shadersAdj[obj.startInd].x, y: this.startLocs[obj.startInd].y - this.shadersAdj[obj.startInd].y }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.idleLetter(obj, mask, obj.startInd);
      });
    }

    if (this.answers.indexOf(null) === -1) {
      this.checkAnswers();
    }
  }

  idleLetter(letter, mask) {
    const randTime = Phaser.Math.Between(3000, 6000);
    const randY = Phaser.Math.Between(10, 30);
    const randDel = Phaser.Math.Between(0, 1500);

    const tween = ABCyaPhaser.Tweens.addTween(letter, randTime, { y: letter.y - randY, delay: randDel, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);
    const tweenM = ABCyaPhaser.Tweens.addTween(mask, randTime, { y: mask.y - randY, yoyo: true, delay: randDel, repeat: -1 }, Phaser.Math.Easing.Quadratic.InOut);

    this.letterTweens.push(tween);
    this.maskTweens.push(tweenM);
  }

  checkAnswers() {
    let ansCheck = 0;
    this.droppedInd = null;

    for (let a = 0; a < this.answers.length; a++) {
      if (this.answers[a] === this.word[a]) {
        ansCheck++;
      }
      else {
        for (let l = 0; l < this.letters.length; l++) {
          if (this.letters[l].ind === a) {
            if (this.answers[a] === this.letters[l].text) {
              this.answers[a] = null;
              this.hints[a].filled = false;
              this.letters[l].ind = null;

              ABCyaPhaser.Tweens.addTween(this.letters[l], 150, { x: this.startLocs[this.letters[l].startInd].x, y: this.startLocs[this.letters[l].startInd].y }, Phaser.Math.Easing.Quadratic.Out);
              ABCyaPhaser.Tweens.addTween(this.masks[l], 150, { x: this.startLocs[this.letters[l].startInd].x - this.shadersAdj[this.letters[l].startInd].x, y: this.startLocs[this.letters[l].startInd].y - this.shadersAdj[this.letters[l].startInd].y }, Phaser.Math.Easing.Quadratic.Out);
            }
          }
        }
      }
    }

    if (ansCheck === this.word.length) {
      gameData.config.levelWordBank.shift();

      this.scene.sub.disableButtons();
      this.scene.navBar.disableButtons();

      this.handleWordSounds();
    }
  }

  handleWordSounds(plusInd) {
    if (plusInd) this.wordInd++;

    this.disableMasks();

    for (let h = 0; h < this.hints.length; h++) {
      this.hints[h].letter.destroy();
    }

    if (this.wordInd >= this.letters.length) {
      ABCyaPhaser.Audio.playOneShot(this.chosenWord, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

      for (let w = 0; w < this.letters.length; w++) {
        if (w === this.letters.length - 1) {
          ABCyaPhaser.Tweens.addTween(this.letters[w], 500, { scaleX: 1.3, scaleY: 1.3 }, Phaser.Math.Easing.Quadratic.In);
          ABCyaPhaser.Tweens.addTween(this.letters[w], 500, { scaleX: 1, scaleY: 1, delay: 500 }, Phaser.Math.Easing.Quadratic.Out, () => {
            this.createDropper();
          });
        }
        else {
          ABCyaPhaser.Tweens.addTween(this.letters[w], 500, { scaleX: 1.3, scaleY: 1.3 }, Phaser.Math.Easing.Quadratic.In);
          ABCyaPhaser.Tweens.addTween(this.letters[w], 500, { scaleX: 1, scaleY: 1, delay: 500 }, Phaser.Math.Easing.Quadratic.Out);
        }
      }
    }
    else {
      ABCyaPhaser.Audio.playOneShot(this.answers[this.wordInd], this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

      let letter;
      for (let l = 0; l < this.letters.length; l++) {
        if (this.letters[l].ind === this.wordInd) {
          letter = this.letters[l];
          break;
        }
      }

      ABCyaPhaser.Tweens.addTween(letter, 500, { scaleX: 1.3, scaleY: 1.3 }, Phaser.Math.Easing.Quadratic.In);
      ABCyaPhaser.Tweens.addTween(letter, 500, { scaleX: 1, scaleY: 1, delay: 500 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.handleWordSounds(true);
      });
    }
  }

  disableMasks() {
    for (let i = 0; i < this.masks.length; i++) {
      this.masks[i].disableInteractive();

      // remove draggable from the mask as well
      this.scene.input.setDraggable(this.masks[i], false);

      this.masks[i].off(Phaser.Input.Events.GAMEOBJECT_DRAG_START);
      this.masks[i].off(Phaser.Input.Events.GAMEOBJECT_DRAG_END);
      this.masks[i].off(Phaser.Input.Events.GAMEOBJECT_DRAG);
    }
  }

  createDropper() {
    this.wordInd = 0;

    this.disableMasks();

    this.enableClick();

    this.scene.navBar.moveSub();

    if (this.initDropper && gameData.config.level === 1) {
      this.scene.createShader();
      this.scene.sub.createSpeech();
    }
    else {
      this.raiseLetters();
    }
  }

  enableClick() {
    for (let i = 0; i < this.masks.length; i++) {
      this.masks[i].setInteractive();
      this.masks[i].on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleClick(this.masks[i]), this);
    }
  }

  /**
   * 
   * @param {Phaser.GameObjects.Zone} obj 
   */
  handleClick(obj) {
    obj.disableInteractive();

    if (this.initDropper) {
      this.raiseLetters();

      this.scene.hideShader();
      this.initDropper = false;
    }

    if (obj.y > 20) {
      const letter = this.letters[obj.startInd];

      this.scene.tweens.killTweensOf(letter);
      this.letterTweens[obj.startInd]?.stop();
      this.scene.tweens.killTweensOf(obj);
      this.maskTweens[obj.startInd]?.stop();

      const vowels = ['a', 'e', 'i', 'o', 'u'];

      if (this.chosenWord.match(/([aeiou])/) === null && this.chosenWord.includes('y')) {
        // the word doesn't include a vowel but does include a `y`, let y count as a vowel
        vowels.push('y');
      }
      if (vowels.indexOf(letter.text) !== -1) {
        this.scene.navBar.chest.burst();

        this.tentacle = new TentancleGrabber(this.scene, { x: obj.x, y: obj.y }, letter, this);
        this.scene.add.existing(this.tentacle);
      }
      else {
        const pop = ABCyaPhaser.Images.addImage(letter.x, letter.y + 10, UIAssetKeys._BblPop_03, this.scene).setScale(2);

        ABCyaPhaser.Tweens.addTween(pop, 250, { scaleX: 4, scaleY: 4 }, Phaser.Math.Easing.Linear, () => pop.destroy());
        ABCyaPhaser.Tweens.addTween(letter, 125, { scaleX: 2, scaleY: 2 }, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(letter, 125, { scaleX: 1.5, scaleY: 1.5, delay: 125 }, Phaser.Math.Easing.Back.Out, () => this.popLetter(letter));
      }

      obj.destroy();
    }
  }

  raiseLetters() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._letters_enter_from_bottom, this.scene);

    for (let i = 0; i < this.boxes.length; i++) {
      if (i === this.boxes.length - 1) {
        ABCyaPhaser.Tweens.addTween(this.boxes[i], 1000, { alpha: 0 }, Phaser.Math.Easing.Linear, () => {
          this.destroyBoxes();
        });
      }
      else {
        ABCyaPhaser.Tweens.addTween(this.boxes[i], 1000, { alpha: 0 }, Phaser.Math.Easing.Linear);
      }

      this.maskTweens[i] = ABCyaPhaser.Tweens.addTween(this.masks[i], 4000, { y: -100 }, Phaser.Math.Easing.Quadratic.In, (tween, targets) => {
        this.destroyMask(targets[0]);
      });

      if (this.initUpdate === false) {
        this.letterTweens[i] = ABCyaPhaser.Tweens.addTween(this.letters[i], 4000, { y: -50 }, Phaser.Math.Easing.Quadratic.In, (tween, targets) => {
          this.updateScore(targets[0]);
        });
      }
      else {
        this.letterTweens[i] = ABCyaPhaser.Tweens.addTween(this.letters[i], 4000, { y: -50 }, Phaser.Math.Easing.Quadratic.In);
      }
    }
  }

  destroyBoxes() {
    for (let i = 0; i < this.boxes.length; i++) {
      this.boxes[i].destroy();
    }

    for (let h = 0; h < this.hints.length; h++) {
      this.hints[h].letter.destroy();
    }
  }

  /**
   * 
   * @param {Phaser.GameObjects.Zone} mask 
   */
  destroyMask(mask) {
    const maskInd = this.masks.indexOf(mask);

    mask.removeAllListeners();
    this.scene.tweens.killTweensOf(mask);
    this.maskTweens[maskInd].stop();
    mask.destroy();

    this.masks.splice(maskInd, 1);
    this.maskTweens.splice(maskInd, 1);
  }

  /**
   * 
   * @param {Phaser.GameObjects.Text} letter 
   */
  updateScore(letter) {
    const letterInd = this.letterTweens.indexOf(letter);
    this.letterTweens.splice(letterInd, 1);

    if (this.letterTweens.length === 0 && this.initUpdate === false) {
      this.cleanUp();
      this.initUpdate = true;

      if (this.score >= gameData.config.maxScore) {
        gameData.config.gameOver = true;
        gameData.config.level++;

        this.createTransition();
      }
      else {
        this.score++;

        this.createWords();
        this.createBoxes();
        this.releaseWords();
      }
    }
  }

  createTransition() {
    this.scene.navBar.tweenOutNav();

    if (gameData.config.level === 5) {
      this.scene.sub.disableButtons();

      this.transition = new Treasure(this.scene, true);
      this.scene.add.existing(this.transition);
    }
    else {
      this.scene.sub.ascend();

      this.transition = new Bubbles(this.scene);
    }
  }

  /**
   * 
   * @param {Phaser.GameObjects.Text} letter 
   */
  popLetter(letter) {
    letter.destroy();

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._not_vowel_octopus, this.scene);

    if (!this.initUpdate) this.updateScore(letter);
  }

  newWord() {
    this.chosenWord = null;
    this.word = null;

    for (let i = 0; i < this.boxes.length; i++) {
      if (i === this.boxes.length - 1) {
        ABCyaPhaser.Tweens.addTween(this.boxes[i], 250, { alpha: 0 }, Phaser.Math.Easing.Linear, () => {
          this.clearWord();
        });
      }
      else {
        ABCyaPhaser.Tweens.addTween(this.boxes[i], 250, { alpha: 0 }, Phaser.Math.Easing.Linear);
      }

      this.scene.tweens.killTweensOf(this.letters[i]);
      this.scene.tweens.killTweensOf(this.masks[i]);
      this.letterTweens[i]?.stop();
      this.maskTweens[i]?.stop();

      this.masks[i].destroy();

      const pop = ABCyaPhaser.Images.addImage(this.letters[i].x, this.letters[i].y + 10, UIAssetKeys._BblPop_03, this.scene).setScale(2);
      this.pops.push(pop);
      ABCyaPhaser.Tweens.addTween(pop, 250, { scaleX: 4, scaleX: 4 }, Phaser.Math.Easing.Linear);

      ABCyaPhaser.Tweens.addTween(this.letters[i], 125, { scaleX: 2, scaleY: 2 }, Phaser.Math.Easing.Linear);
      ABCyaPhaser.Tweens.addTween(this.letters[i], 125, { scaleX: 1.5, scaleY: 1.5, delay: 125 }, Phaser.Math.Easing.Back.Out);
    }
  }

  clearWord() {
    this.cleanUp();
    this.initUpdate = true;

    this.createWords();
    this.createBoxes();
    this.releaseWords();
  }

  showHint() {
    for (let h = 0; h < this.hints.length; h++) {
      console.log(this.hints[h].letter.alpha, this.hints[h].filled);
      if (this.hints[h].letter.alpha === 0 && this.hints[h].filled === false) {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
        this.hints[h].letter.alpha = .5;
        return;
      }
    }
  }

  cleanUp() {
    for (let b = 0; b < this.boxes.length; b++) {
      this.boxes[b].destroy();
    }

    for (let h = 0; h < this.hints.length; h++) {
      this.hints[h].letter.destroy();
    }

    if (this.pops.length > 0) {
      for (let p = 0; p < this.pops.length; p++) {
        this.pops[p].destroy();
      }
    }

    for (let a = 0; a < this.answers.length; a++) {
      this.answers[a] = null;
    }

    if (this.letters.length > 0) {
      for (let l = 0; l < this.letters.length; l++) {
        this.scene.tweens.killTweensOf(this.letters[l]);
        this.letterTweens[l]?.stop();
        this.letters[l].destroy();
      }
    }

    if (this.masks.length > 0) {
      for (let m = 0; m < this.masks.length; m++) {
        this.scene.tweens.killTweensOf(this.masks[m]);
        this.maskTweens[m]?.stop();
        this.masks[m].destroy();
      }
    }

    if (gameData.config.gameOver && this.transition instanceof Treasure) {
      this.transition.cleanUp();
      this.transition.destroy();
    }

    this.wordInd = 0;

    this.boxCont.destroy();
    this.pops = [];
    this.letters = [];
    this.hints = [];
    this.boxes = [];
    this.masks = [];
    this.answers = [];
    this.startLocs = [];
    this.shadersAdj = [];
    this.letterTweens = [];
    this.maskTweens = [];

    this.droppedInd = null;
    this.returnInd = null;
    this.word = null;
  }
}

function compareArrays(array1, array2) {
  // compare lengths - can save a lot of time
  if (array1.length !== array2.length)
    return false;

  for (let i = 0, l = array1.length; i < l; i++) {
    // Check if we have nested arrays
    if (array1[i] instanceof Array && array2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!array1[i].equals(array2[i]))
        return false;
    }
    else if (array1[i] !== array2[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
}